/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Profeature41Inputs */

const zh_plan_profeature41 = /** @type {(inputs: Plan_Profeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级 AI 模型`)
};

const en_plan_profeature41 = /** @type {(inputs: Plan_Profeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced AI models`)
};

const es_plan_profeature41 = /** @type {(inputs: Plan_Profeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de IA avanzados`)
};

/**
* | output |
* | --- |
* | "Advanced AI models" |
*
* @param {Plan_Profeature41Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_profeature41 = /** @type {((inputs?: Plan_Profeature41Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Profeature41Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_profeature41(inputs)
	if (locale === "en") return en_plan_profeature41(inputs)
	return es_plan_profeature41(inputs)
});
export { plan_profeature41 as "plan_proFeature4" }